module.exports = __webpack_public_path__ + "static/header-img-recording-d7b320b0005efea59508ab3ead967163.jpg";